//core
import React, { useState, useEffect, useContext } from "react";
import arePropsEqual from "react-fast-compare";
import { Tooltip, useMediaQuery } from "@mui/material";

//styles
import { useStyles } from "./styles";

//routes
import routes from "../../../../../navigation/routes";

//context
import { TableContext } from "../../../../admin/Reports/AgentStatisticsReport/components/DesktopReport/TableContext";

//store
import { useUser } from "../../../../../store/common/user/useUser";
import { useLocation } from "react-router-dom";

interface IClickableAgentIdProps {
  value: string | number;
}

const ClickableAgentId = ({ value = "" }: IClickableAgentIdProps) => {
  const styles = useStyles();
  const mobile = useMediaQuery("(max-width:767px)");
  const location = useLocation();
  const { user } = useUser();
  const context = useContext(TableContext);

  const [link, setLink] = useState<string>("");

  const isFullUserList = location.pathname.includes("full-user-list");
  const isAdmin = user.user.namespace === "admin";

  useEffect(() => {
    if (isAdmin) {
      const baseRoute =
        isFullUserList || context?.toggleAllStats
          ? routes.admin.agent.fullAgentsList.profile.replace(":id", `${value}`)
          : routes.admin.agent.list.profile.replace(":id", `${value}`);

      setLink(`${baseRoute}`);
    } else {
      setLink(
        `${routes.agent.agentsList.agentProfile.replace(":id", `${value}`)}`
      );
    }
  }, [context?.toggleAllStats, isAdmin, isFullUserList, value]);

  return (
    <>
      {value ? (
        mobile ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.text}`}
          >
            {value}
          </a>
        ) : (
          <Tooltip title={value}>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.text}`}
            >
              {value}
            </a>
          </Tooltip>
        )
      ) : (
        "—"
      )}
    </>
  );
};

export default React.memo(ClickableAgentId, arePropsEqual);
